
export const textileOrderIdFromMatch = (match?: any): number | undefined =>
parseInt(match?.params?.textileOrderId || '0', 10) || undefined;
